<div class="flex flex-col gap-8"
     [formGroup]="form()"
>
  <div class="comparison-grid expanded-mode"
       data-test="certificate-meta-data-comparison-grid"
  >
    <div>
      <p-table data-test="certificate-meta-data-table-left"
               [value]="leftTableData()"
      >
        <ng-template #body
                     let-row
        >
          <tr>
            <td class="font-bold">{{ row.label }}</td>
            <td [pTooltip]="row.tooltip">{{ row.value ?? '-' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="override-cell">
      <p-table data-test="certificate-meta-data-table-right"
               [value]="rightTableData()"
      >
        <ng-template #body
                     let-row
        >
          <tr>
            <td class="font-bold">{{ row.label }}</td>
            <td [pTooltip]="row.tooltip">{{ row.value ?? '-' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>
